import useFilterButton from "./filterButton"

const useButtonsHooks = () => {
    return {
        useFilterButton,
    }
}

export default useButtonsHooks